import { number, string, table } from "@rocicorp/zero";

export const userAssignment = table("userAssignments")
	.from("user_assignments")
	.columns({
		id: string(),
		crewId: string().from("crew_id"),
		ranking: number(),
		userId: string().from("user_id"),
		planId: string().from("plan_id"),
		createdBy: string().from("created_by"),
		createdAt: number().from("created_at"),
		// The crew's organisation, not the plan's: staffing a crew is its owner's right, and on
		// a partner crew the two differ, which is why the mutators name it.
		orgId: string().from("org_id"),
	})
	.primaryKey("id");
